export default {
  //AdminModal Component
  "AdminModal.deleteMessage": "¿Está seguro de que desea realizar esta acción?",
  "AdminModal.yesDelete": "Sí, Eliminar",

  //Inspections
  "Inspections.delete.success": "Inspección eliminada exitosamente",
  "Inspections.delete.error": "La inspección no pudo ser eliminada",
  "Inspections.table.dueDate.label": "Fecha Límite",
  "Inspections.table.completeDate.label": "Fecha de Finalización",
  "Inspections.table.all.placeholder": "Buscar inspecciones por nombre de plantilla, propiedad, etc.",
  "Inspections.table.all.username": "Asignado a",
  "Inspections.table.all.viewReport": "Ver Reporte",
  "Inspections.table.all.editInspection": "Editar Inspección",
  "Inspections.table.all.deleteInspection": "Eliminar Inspección",
  "Inspections.table.assigned.placeholder": "Buscar inspecciones por nombre de plantilla, propiedad, etc.",
  "Inspections.table.completed.placeholder": "Buscar inspecciones por nombre de plantilla, propiedad, etc.",
  "Inspections.table.properties.placeholder": "Buscar propiedades por nombre o dirección",
  "Inspections.table.properties.inspections": "Inspecciones",
  "Inspections.tabs.assigned": "Asignadas",
  "Inspections.tabs.completed": "Completadas",
  "Inspections.tabs.all": "Todas",
  "Inspections.tabs.properties": "Propiedades",
  "Inspections.tabs.watching": "Observando",
  "Inspections.tabs.watching.score": "Puntaje de inspección",
  "Inspections.properties.inspections": "{count, plural, =0 {# Inspecciones} one {# Inspección} other {# Inspecciones}}",
  "Inspections.properties.goBack": "Volver a Propiedades",
  "Inspections.deleteInspection": "Eliminar inspección",
  "Inspections.delete.modal.title": "Sí, Eliminar",
  "Inspections.delete.modal.message": "¿Está seguro de que desea eliminar esta inspección?",
  "Inspection.denyInspection": "Denegar inspección",
  "Inspection.approveInspection": "Aprobar inspección",
  "Inspection.cancelInspection": "Cancelar inspección",
  "Inspection.modal.cancel": "Sí, Cancelar",
  "Inspection.modal.deny": "Sí, Denegar",
  "Inspection.modal.approve": "Sí, Aprobar",
  "Inspection.modal.denyInspection": "¿Está seguro de que desea denegar los resultados de la inspección?",
  "Inspection.modal.approveInspection": "Una vez aprobada, esta inspección ya no podrá modificarse.",
  "Inspection.modal.cancelInspection": "¿Está seguro de que desea cancelar esta inspección?",

  "WorkOrders.delete.success": "Orden de trabajo eliminada exitosamente",
  "WorkOrders.delete.error": "La orden de trabajo no pudo ser eliminada",
  "WorkOrders.table.dueDate.label": "Prioridad",
  "WorkOrders.table.all.placeholder": "Buscar órdenes de trabajo por nombre, propiedad, etc.",
  "WorkOrders.table.all.username": "Asignado  a",
  "WorkOrders.table.all.viewWorkOrder": "Ver Orden de Trabajo",
  "WorkOrders.table.all.editWorkOrder": "Editar Orden de Trabajo",
  "WorkOrders.table.all.deleteWorkOrder": "Eliminar Orden de Trabajo",
  "WorkOrders.table.assigned.placeholder": "Buscar órdenes de trabajo por nombre, propiedad, etc.",
  "WorkOrders.table.completed.placeholder": "Buscar órdenes de trabajo por nombre, propiedad, etc.",
  "WorkOrders.table.properties.placeholder": "Buscar propiedades por nombre o dirección",
  "WorkOrders.table.properties.workOrders": "Órdenes de Trabajo",
  "WorkOrders.tabs.assigned": "Mis órdenes de trabajo",
  "WorkOrders.tabs.completed": "Órdenes de Trabajo Completadas",
  "WorkOrders.tabs.all": "Todas las Órdenes de Trabajo",
  "WorkOrders.tabs.watching": "Siguiendo",
  "WorkOrders.tabs.properties": "Propiedades",
  "WorkOrders.properties.workOrders": "{count, plural, =0 {# Órdenes de Trabajo} one {# Orden de Trabajo} other {# Órdenes de Trabajo}}",
  "WorkOrders.properties.goBack": "Volver a Propiedades",
  "WorkOrders.title": "Tablero de Órdenes de Trabajo",
  "WorkOrders.deleteWorkOrder": "Eliminar Orden de Trabajo",
  "WorkOrders.delete.modal.title": "Sí, Eliminar",
  "WorkOrders.delete.modal.message": "¿Está seguro de que desea eliminar esta orden de trabajo?",
  "WorkOrders.table.reporter": "Reportado por",
  "WorkOrders.table.assignee": "Asignado a",
  "WorkOrders.table.dueDate": "Fecha límite",
  "WorkOrders.table.actualCost": "Costo real",
  "WorkOrders.table.quotedCost": "Costo presupuestado",
  "WorkOrders.table.coi": "Certificado de seguro (COI)",
  "WorkOrders.table.coiPending": "Certificado de seguro (COI) pendiente",
  "WorkOrders.table.openCoi": "Abrir certificado de seguro (COI)",
  "WorkOrders.table.all.manageCOI": "Administrar certificado de seguro (COI)",

  "MoneyInput.customPlaceholder": "Ingrese monto en dólares",
  "MoneyInput.placeholder": "Seleccione el estimado en dólares",

  //MultipleMediaUpload Component
  "MultipleMediaUpload.deletePhoto": "Eliminar Foto",
  "MultipleMediaUpload.uploadPhotos": "Subir Fotos",
  "MultipleMediaUpload.deleteVideo": "Eliminar Video",
  "MultipleMediaUpload.uploadVideos": "Subir Videos",
  "MultipleMediaUpload.upload": "Subir",
  "MultipleMediaUpload.delete": "Eliminar",
  "MultipleMediaUpload.dropPhotosHere": "Suelta las fotos aquí",
  "MultipleMediaUpload.dropVideosHere": "Suelta los videos aquí",

  "Notes.title": 'Notas',
  "Notes.empty": 'No hay notas registradas',

  //PasswordInput component
  "PasswordInput.password": "Contraseña",
  "PasswordInput.createPassword": "Crear contraseña",
  "PasswordInput.strength.veryWeak": "Muy débil",
  "PasswordInput.strength.weak": "Débil",
  "PasswordInput.strength.good": "Buena",
  "PasswordInput.strength.strong": "Fuerte",
  "PasswordInput.strength.veryStrong": "Muy Fuerte",
  "PasswordInput.strength": "Fuerza de la contraseña",
  "PasswordInput.mustMatch.error": "Passwords must match",
  "PasswordInput.confirm": "Confirmar contraseña",
  "PasswordInput.tooltip.label": "La contraseña debe",
  "PasswordInput.showHide.alt": "mostrar/ocultar contraseña",

  //ColorPicker Component
  "ColorPicker.chooseHex": "Elija color HEX#",
  "ColorPicker.hex": "HEX#",
  "ColorPicker.opacity": "Opacidad",

  //DragDropImageUpload component
  "DragDropImageUpload.upload": "Suba un archivo",
  "DragDropImageUpload.dragDrop": "o arrastre y suelte",
  "DragDropImageUpload.fileTypes": "{fileTypes} de hasta {fileSize}",
  "DragDropImageUpload.addPhoto": "Subir Foto",
  "DragDropImageUpload.replaceImage": "Reemplazar Imagen",
  "DragDropImageUpload.removeImage": "Eliminar Imagen",
  "DragDropImageUpload.drop": "Suelte para subir",

  //inputValidationRules
  "inputValidationRules.requiredRule": "{item} es un dato obligatorio",
  "inputValidationRules.minLengthRule": "contener al menos {minCharacters} caracteres",
  "inputValidationRules.maxLengthRule": "no puede contener más de {maxCharacters} caracteres",
  "inputValidationRules.hasUpperCaseRule": "contener al menos una letra en mayúscula",
  "inputValidationRules.hasLowerCaseRule": "contener al menos una letra en minúscula",
  "inputValidationRules.hasNumberRule": "contener al menos un número",
  "inputValidationRules.isValidEmailRule": "debe ser una dirección de correo electrónico válida",
  "inputValidationRules.passwordStrengthRule": "ser una contraseña fuerte",

  //RatingScale Component
  "RatingScale.default.1": "Malo",
  "RatingScale.default.2": "Insuficiente",
  "RatingScale.default.3": "Regular",
  "RatingScale.default.4": "Bueno",
  "RatingScale.default.5": "Excelente",
  "RatingScale.default.NA": "N/A",

  "SelectWithCustomInput.placeholder": "Ingrese valor personalizado",
  "SelectWithCustomInput.customValue": "Valor Personalizado",

  "YesNo.default.0": "No",
  "YesNo.default.1": "Sí",
  "YesNo.default.NA": "N/A",

  "TagSelector.select": "Por favor seleccione una etiqueta",
  "TagSelector.placeholder": "Escriba y seleccione múltiples etiquetas...",
  "TagSelector.noOptions": "No quedan etiquetas por seleccionar",
  "TagSelector.clear": "Eliminar Etiquetas",

  "Task.viewAssetInSiteplan": "Ver en Plano del Sitio",

  /************************************************************
 * General Use
 * -----------------------------------
 * General use translations that are used throughout the
 * application in multiple components
 ************************************************************/
  //Error Message
  "error.general": "Ocurrió un error",
  "error.server": "El servidor no responde",
  "error.spaceProfile.create": "Hubo un error al crear el perfil del espacio.",
  "error.deleteFile": "Hubo un error al eliminar el archivo.",
  "error.iconNotFound": "Icono de carga {icon} no encontrado. Usando el icono predeterminado.",
  "error.notAvailable": "No Disponible",
  "error": "Error",
  "error.required": "{field} es obligatorio",
  "error.valid": "Ingrese un valor válido para {field}",
  "error.addNewLevel": "Se produjo un error al agregar un nuevo nivel",

  //Files
  "file.floorplan": "Planta baja",
  "file.featured": "Imagen destacada",
  "file.autocad": "AUTOCAD",
  "file.pdf": "PDF LOD",
  "file.profile_pdf": "PDF de perfil",

  //Floor Labels
  "floorLabels.basement1": "Subsuelo 1",
  "floorLabels.basement2": "Subsuelo 2",
  "floorLabels.groundFloor": "Planta Baja",
  "floorLabels.mainFloor": "Piso Principal",
  "floorLabels.mezzanine": "Entrepiso",
  "floorLabels.level": "Piso {level}",

  //Hooks
  "hooks.useSections.error": "No se pudieron obtener las secciones",
  "hooks.useAssets.error": "No se pudieron obtener los activos",
  "hooks.useMenu.error": "No se pudieron obtener las propiedades",
  "hooks.useWorkOrders.error": "No se pudieron obtener las órdenes de trabajo",
  "hooks.useInspectionInstances.error": "No se pudieron obtener las inspecciones",

  //Platform Related Language
  "platform.roles.admin": "Admininstrador",

  "term.company": "Compañía",
  "term.property": "Propiedad",
  "term.user": "Usuario",
  "term.template": "Plantilla",
  "term.task": "Tarea",
  "term.unavailable": "No Disponible",
  "term.available": "Disponible",
  "term.visible": "Visible",
  "term.required": "Requerido",
  "term.enabled": "Activado",
  "term.unit": "Unidad",
  "term.unit_no": "Unidad #",
  "term.address": "Dirección",
  "term.unknown": "Desconocido",
  "term.search": "Buscar",
  "term.filters": "Filtros",
  "term.resetFilters": "Borrar filtros",
  "term.assetType": "Tipo de Activo",
  "term.floorplan": "Plano del piso",
  "term.asset": "Activo",
  "term.published": "publicado",
  "term.unpublished": "sin publicar",
  "term.draft": "borrador",
  "term.other": "Otro",
  "term.location": "Ubicación",
  "term.vendor": "Proveedor",
  "term.space": "Espacio",
  "term.vacant": "Vacante",
  "term.occupied": "Ocupado",
  "term.sqFootage": "Pies Cuadrados",
  "term.state": "State",
  "term.id": "ID",
  "term.idpRecord": "ID de registro ID360",
  "term.leasable": "Arrendable",
  "term.notLeasable": "No Arrendable",
  "term.priority": "Prioridad",
  "term.priority.Low": "Baja",
  "term.priority.Medium": "Media",
  "term.priority.High": "Alta",
  "term.priority.Urgent": "Urgente",
  "term.status.Created": "Creado",
  "term.status.Assigned": "Asignado",
  "term.status.Scheduled": "Programado",
  "term.status.Work in progress": "Trabajo en Progreso",
  "term.status.Approved": "Aprobado",
  "term.status.Pending approval": "Pendiente de Aprobación",
  "term.status.Paused": "Pausado",
  "term.status.Cancelled": "Cancelado",
  "term.status": "Estado",
  "term.status.Vendor Assigned": "Asignado a Proveedor",
  "term.status.Pending Vendor Acceptance": "Pendiente de Aprobación del Proveedor",
  "term.status.Vendor Accepted": "Proveedor Aceptó",
  "term.status.Vendor Declined": "Proveedor Rechazó",
  "term.status.Work in Progress": "Trabajo en Progreso",
  "term.status.Submitted for Approval": "Enviado para Aprobación",
  "term.status.Review": "Revisión",
  "term.status.Accepted": "Aceptado",
  "term.status.Declined": "Rechazado",
  "term.status.Invoice Requested": "Factura Solicitada",
  "term.status.Invoice Submitted": "Factura Enviada",
  "term.status.Invoice Accepted": "Factura Aceptada",
  "term.status.Completed": "Completado",
  "term.workOrders": "Órdenes de Trabajo",
  "term.workOrder": "Orden de Trabajo",
  "term.between": "Desde {start} hasta {end}",
  "term.interval": "Intervalo",
  "term.exclusive": "Exclusivo",
  "term.inclusive": "Inclusivo",
  "term.exclusiveShort": "exc.",
  "term.inclusiveShort": "inc.",
  "term.startingFrom": "Desde {start}",
  "term.upTo": "Hasta {end}",
  "term.leaseTerm": "Plazo de arrendamiento",
  "term.pendingLease": "Arrendamiento Pendiente",
  "term.leaseOption": "Opción",
  "term.leased": "Arrendado",
  "term.notActive": "No Activo",
  "term.active": "Activo",
  "term.expired": "Vencido",
  "term.anchor": "Ancla",
  "term.publishedDate": "Fecha de Publicación",
  "term.email": "E-mail",

  //Calendar
  "Calendar.monday": "Lunes",
  "Calendar.tuesday": "Martes",
  "Calendar.wednesday": "Miércoles",
  "Calendar.thursday": "Jueves",
  "Calendar.friday": "Viernes",
  "Calendar.saturday": "Sábado",
  "Calendar.sunday": "Domingo",
  "Calendar.january": "Enero",
  "Calendar.february": "Febrero",
  "Calendar.march": "Marzo",
  "Calendar.april": "Abril",
  "Calendar.may": "Mayo",
  "Calendar.june": "Junio",
  "Calendar.july": "Julio",
  "Calendar.august": "Agusto",
  "Calendar.september": "Septiembre",
  "Calendar.october": "Octubre",
  "Calendar.november": "Noviembre",
  "Calendar.december": "Diciembre",

  //Terms specific to CRM system
  "crm.new": "Nuevo",
  "crm.scheduled": "Programado",
  "crm.complete": "Completo en el campo",
  "crm.delivered": "Entregado",
  "crm.hold": "En espera",
  "crm.canceled": "Cancelado",

  //UI elements (common UI buttons, interactions)
  "ui.saving": "Guardando",
  "ui.loading": "Cargando",
  "ui.addressDisplay": "{address}, {city}, {stateOrRegion} {postal}",
  "ui.logout": "Cerrar Sesión",
  "ui.uploadItem": "Subir {item}",
  "ui.uploading": "Subiendo",
  "ui.default": "Predeterminado",
  "ui.theme": "Tema",
  "ui.themeTemplate": "Tema {name}",
  "ui.goBack": "Volver",
  "ui.close": "Cerrar",
  "ui.delete": "Eliminar",
  "ui.cancel": "Cancelar",
  "ui.deleting": "Eliminando",
  "ui.save": "Guardar",
  "ui.details": "Detalles",
  "ui.uploads": "Subidas",
  "ui.photos": "Fotos",
  "ui.images": "Imágenes",
  "ui.reference": "Referencia",
  "ui.unitNo": "{unit} #",
  "ui.select": "Seleccione",
  "ui.ok": "OK",
  "ui.yes": "Sí",
  "ui.no": "No",
  "ui.next": "Siguiente",
  "ui.view": "Ver",
  "ui.noResults": "No hay resultados",
  "ui.all": "Todo",
  "ui.totalCount": "{count} en Total",
  "ui.monthRange": "{number} Meses",
  "ui.yearRange": "{number} Años",
  "ui.viewMore": "Ver Más",
  "ui.dataNotFound": "No se encontraron datos",
  "ui.edit": "Editar",
  "ui.download": "Descargar",
  "ui.available": "Disponible",
  "ui.settings": "Configuración",
  "ui.print": "Imprimir",
  "ui.areYouSure": "¿Está seguro?",
  "ui.name": "Nombre",
  "ui.size": "Tamaño",
  "ui.uploadDate": "Fecha de subida",
  "ui.uploadedBy": "Subido por",
  "ui.uploadAFile": "Subir un archivo",
  "ui.uploadFiles": "Subir fotos",
  "ui.uploadedFiles": "Archivos subidos",
  "ui.videos": "Videos",
  "ui.pause": "Pausa",
  "ui.update": "Actualizar",
  "ui.updating": "Actualizando",
  "ui.description": "Descripción",
  "ui.type": "Tipo",
  "ui.label": "Etiqueta",
  "ui.add": "Agregar",
  "ui.resume": "Continuar",
  "ui.start": "Comenzar",
  "ui.status": "Estado",
  "ui.open": "Abierto",
  "ui.you": "Usted",
  "ui.approve": "Aprobar",
  "ui.deny": "Denegar",
  "ui.submitting": "Enviando",
  "ui.submit": "Enviar",
  "ui.unassigned": "Sin asignar",
  "ui.after": "Después",
  "ui.before": "Antes",
  "ui.files": "Archivos",
  "ui.links": "Enlaces",
  "ui.remove": "Eliminar",
  "ui.list": "Listar",
  "ui.pin": "PIN",
  "ui.phoneNumber": "Número de teléfono",

  "DetailPane.paging": "{current} de {total}",

  "Comments.signUp": "Registrarse", // this is for: https://idplans.atlassian.net/browse/IDI-257
  "Comments.post": "Publicar",
  "Comments.inputPlaceholder": "Escriba un comentario... (use @ para mencionar a otras personas)",
  "Comments.title": "Comentarios",
  "Comments.singularTitle": "Comentario",
  "Comments.edit": "Editar",
  "Comments.delete": "Eliminar",
  "Comments.postedOn": "Publicado {date}",
  "Comments.editedOn": "Editado {date}",
  "Comments.authorSaid": "{author} dijo:",
  "Comments.youSaid": "Usted dijo:",
  "Comments.youRepliedTo": "Usted respondió a {author}:",
  "Comments.reply": "Responder",
  "Comments.save": "Guardar",
  "Comments.cancel": "Cancelar",

  "sections.videoMap": "Videomapa",
  "sections.er": "Respuesta a Emergencias",
  "sections.bg": "Fondo",
  "sections.bs": "Básico",
  "sections.blank": "En blanco",
  "sections.dump": "Basurero",
  "sections.dimensions": "Dimensiones",
  "sections.gas": "Gas",
  "sections.fire": "Fuego",
  "sections.irrig": "Irrigación",
  "sections.land": "Paisaje",
  "sections.light": "Iluminación",
  "sections.loc": "Ubicación",
  "sections.park": "Aparcamiento",
  "sections.pave": "Pavimento",
  "sections.ps": "Letrero de Pilón",
  "sections.info": "Info",
  "sections.roof": "Techo",
  "sections.sat": "Satélite",
  "sections.sign": "Señalización",
  "sections.space": "Espacio",
  "sections.water": "Agua",
  "sections.hvac": "HVAC",
  "sections.elec": "Electricidad",

  //SearchTable Component
  "SearchTable.pageCounter": "Página {current} de {total}",

  //SearchTable Storybook
  "SearchTable.all": "Todo",
  "SearchTable.active": "Activo",
  "SearchTable.inactive": "Inactivo",
  "SearchTable.pending": "Pendiente",
  "SearchTable.published": "Publicado",
  "SearchTable.unpublished": "Sin Publicar",
  "SearchTable.draft": "Borrador",
  "SearchTable.fname": "Usuario",
  "SearchTable.city": "Ubicación",
  "SearchTable.company": "Empresa",
  "SearchTable.status": "Estado",
  "SearchTable.actions": "Acciones",
  "SearchTable.actions.edit": "Editar",
  "SearchTable.actions.delete": "Borrar",
  "SearchTable.actions.contact": "Contactar",
  "SearchTable.actions.share": "Cuota",
  "SearchTable.addUser": "Agregar",
  "SearchTable.removeUser": "Eliminar",
  "SearchTable.permissions": "Seleccionar Permisos",
  "SearchTable.permissions.editor": "Editor",
  "SearchTable.permissions.viewer": "Lector",
  "SearchTable.label": "Todos los Proveedores",
  "SearchTable.tabs.all": "Todos los Usuarios",
  "SearchTable.tabs.vendors": "Proveedores",
  "SearchTable.tabs.all.placeholder": "Filtrar todos los usuarios por nombre o ubicación",
  "SearchTable.tabs.vendors.placeholder": "Filtrar proveedores por nombre o ubicación",

  "TestTable.filterSpaces.placeholder": "Filtrar todos los espacios por nombre o ubicación",
  "TestTable.sections.spaces": "Espacios",
  "TestTable.sections.hvac": "HVAC",
  "TestTable.sections.fire": "Fuego",
  "TestTable.sections.irrigation": "Irrigación",
  "TestTable.removeSpace": "Eliminar",
  "TestTable.addSpace": "Agregar Espacio",
  "TestTable.created": "Creado"
}
